// @flow
import Input from "./Input";

export const CustomInput = ({
  type,
  validator,
  value,
  onChange,
  placeholder,
  options,
  error,
  showBadge,
  isSpaceRequired = false,
  containerStyles,
  inputStyles,
  maxLength,
  disabled = false,
  onPressEnter,
  autoFocus,
  isPassword,
  isSvgIconRequired,
  isOtpField,
  dataTestId,
  autoComplete = true,
  filterFocus,
  addMoney,
  dropdownImage,
  dropdownStyle,
  isLogin,
  inputcomponentStyles,
  rightIcon,
  isRightIconRequired,
}) => {
  let defaultContainerStyles = {
    paddingTop: 5,
    display: "flex",
    flexDirection: "column",
  };

  let defaultInputStyles = {
    boxShadow: "0.1px 0.1px 0.5px 1px white",
    borderRadius: 5,
    fontSize: 12,
    color: "black",
    height: 38,
    outline: "none",
    paddingTop: 3,
    paddingBottom: 3,
  };
  return (
    <Input
      maxLength={maxLength}
      type={type}
      validator={validator}
      value={value}
      isSpaceRequired={isSpaceRequired}
      disabled={disabled}
      styles={{
        ...defaultInputStyles,
        ...inputStyles,
      }}
      showBadge={showBadge}
      showErrorMsg={error}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      onPressEnter={onPressEnter}
      autoFocus={autoFocus}
      isPassword={isPassword}
      isSvgIconRequired={isSvgIconRequired}
      containerStyles={{
        ...defaultContainerStyles,
        ...containerStyles,
      }}
      imageUpload
      isOtpField={isOtpField}
      dataTestId={dataTestId}
      autoComplete={autoComplete}
      filterFocus={filterFocus}
      setNamesError={() => {}}
      addMoney={addMoney}
      dropdownImage={dropdownImage}
      dropdownStyle={{ ...dropdownStyle }}
      isLogin={isLogin}
      inputcomponentStyles={inputcomponentStyles}
      isRightIconRequired={isRightIconRequired}
      rightIcon={rightIcon}
    />
  );
};
